// extracted by mini-css-extract-plugin
module.exports = {"Title":"Title--OXOqw"};